export default "__VITE_ASSET__CppzAtu0__"